module.exports = "/assets/data/4efb87b7bcc648e959dc11b53a9820bf-TN8.data.json";